"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketRuleValueType = exports.MarketRuleQualifierParseMode = exports.MarketRuleOperator = exports.FieldType = void 0;
var FieldType;
(function (FieldType) {
    FieldType[FieldType["Alphanumeric"] = 0] = "Alphanumeric";
    FieldType[FieldType["Price"] = 1] = "Price";
    FieldType[FieldType["Integer"] = 2] = "Integer";
    FieldType[FieldType["Date"] = 3] = "Date";
    FieldType[FieldType["Time"] = 4] = "Time";
    FieldType[FieldType["Enumerated"] = 5] = "Enumerated";
    FieldType[FieldType["Binary"] = 6] = "Binary";
})(FieldType || (exports.FieldType = FieldType = {}));
var MarketRuleOperator;
(function (MarketRuleOperator) {
    MarketRuleOperator[MarketRuleOperator["Exist"] = 0] = "Exist";
    MarketRuleOperator[MarketRuleOperator["NotExist"] = 1] = "NotExist";
    MarketRuleOperator[MarketRuleOperator["Contains"] = 2] = "Contains";
    MarketRuleOperator[MarketRuleOperator["NotContains"] = 3] = "NotContains";
    MarketRuleOperator[MarketRuleOperator["And"] = 4] = "And";
    MarketRuleOperator[MarketRuleOperator["Or"] = 5] = "Or";
    MarketRuleOperator[MarketRuleOperator["Equal"] = 6] = "Equal";
    MarketRuleOperator[MarketRuleOperator["NotEqual"] = 7] = "NotEqual";
    MarketRuleOperator[MarketRuleOperator["GraterThan"] = 8] = "GraterThan";
    MarketRuleOperator[MarketRuleOperator["GraterThanOrEqualTo"] = 9] = "GraterThanOrEqualTo";
    MarketRuleOperator[MarketRuleOperator["LessThan"] = 10] = "LessThan";
    MarketRuleOperator[MarketRuleOperator["LessThanOrEqualTo"] = 11] = "LessThanOrEqualTo";
})(MarketRuleOperator || (exports.MarketRuleOperator = MarketRuleOperator = {}));
var MarketRuleQualifierParseMode;
(function (MarketRuleQualifierParseMode) {
    MarketRuleQualifierParseMode[MarketRuleQualifierParseMode["DataNumeric"] = 0] = "DataNumeric";
    MarketRuleQualifierParseMode[MarketRuleQualifierParseMode["DataAnonFields"] = 1] = "DataAnonFields";
    MarketRuleQualifierParseMode[MarketRuleQualifierParseMode["DataNumberedFields"] = 2] = "DataNumberedFields";
    MarketRuleQualifierParseMode[MarketRuleQualifierParseMode["DataString"] = 3] = "DataString";
})(MarketRuleQualifierParseMode || (exports.MarketRuleQualifierParseMode = MarketRuleQualifierParseMode = {}));
var MarketRuleValueType;
(function (MarketRuleValueType) {
    MarketRuleValueType[MarketRuleValueType["FidCurrent"] = 0] = "FidCurrent";
    MarketRuleValueType[MarketRuleValueType["FidPrevious"] = 1] = "FidPrevious";
    MarketRuleValueType[MarketRuleValueType["FidLatest"] = 2] = "FidLatest";
    MarketRuleValueType[MarketRuleValueType["Constant"] = 3] = "Constant";
    MarketRuleValueType[MarketRuleValueType["CaptureTimestampMessage"] = 4] = "CaptureTimestampMessage";
    MarketRuleValueType[MarketRuleValueType["RTLMessage"] = 5] = "RTLMessage";
    MarketRuleValueType[MarketRuleValueType["RICRecord"] = 6] = "RICRecord";
    MarketRuleValueType[MarketRuleValueType["EnvValue"] = 7] = "EnvValue";
    MarketRuleValueType[MarketRuleValueType["TemplateNumberRecord"] = 8] = "TemplateNumberRecord";
})(MarketRuleValueType || (exports.MarketRuleValueType = MarketRuleValueType = {}));
